function main() {
    const needResourceList = [
      window.$,
      window.jQuery,
      window.Swiper,
    ]

    if (needResourceList.filter(Boolean).length !== needResourceList.length) {
        return setTimeout(main, 240)
    }

    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080;
    $('#root').css('zoom', scale)

    window.addEventListener('resize', function () {
        var timer;
        return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
                $('#root').css('zoom', 'normal')
                let scale = document.body.clientWidth / 1080;
                $('#root').css('zoom', scale)
            }, 100)
        }
    }())

    jQuery(".txtMarquee-left").slide({
        mainCell: ".bd ul",
        autoPlay: true,
        effect: "leftMarquee",
        interTime: 15,
        trigger: "click",
    });

    //购物车
    $(".addCart").click(function () {
        var num1 = Number($(".gwcNum").html());
        var num2 = Number($(".quan input").val());
        var num3 = num1 + num2;
        $(".gwcNum").html(num1);
    });
    //
    var swiper = new Swiper(".off .mySwiper", {
        loop: true,
        autoplay: true,
    });
    //
    var swiper = new Swiper(".sp_layer5 .mySwiper", {
        loop: true,
        autoplay: true,
    });
    $(".dl1 dd").click(function () {
        $(this).addClass("on").siblings().removeClass("on");
        var num = $(this).index();
        $(".icon1>div").eq(num).fadeIn().siblings().hide();
    });
    $(".dl2 dd").click(function () {
        $(this).addClass("on").siblings().removeClass("on");
        var num2 = $(this).index();
        $(".icon2>div").eq(num2).fadeIn().siblings().hide();
    });
    $(".dl3 dd").click(function () {
        $(this).addClass("on").siblings().removeClass("on");
        var num3 = $(this).index();
        $(".icon3>div").eq(num3).fadeIn().siblings().hide();
    });

    $('.buyNow').click(function () {
        let id = $(this).parents(".nowBox").siblings(".listBox").find('.buyTxt dl dd.on').attr('data-id')
        let num = $(this).siblings(".addCart").find('.font_num').html()
        window.location.href = '/cart/' + id + ':' + num
    })

    $(".addCart .add").click(function () {
        let num = $(this).parents(".addCart").find(".font_num").html()
        let newNum = Number(num) + 1
        $(this).parents(".addCart").find(".font_num").html(newNum)
    });
    $(".addCart .reduce").click(function () {
        let num = $(this).parents(".addCart").find(".font_num").html()
        let newNum = Number(num) - 1
        if (newNum >= 1) {
            $(this).parents(".addCart").find(".font_num").html(newNum)
        }
    });

    $('.buy').click(function () {
        const targetElement = document.querySelector('.MaoBuyBox');
        const offsetTop = targetElement.offsetTop;
        window.scroll({
            top: (offsetTop - 240) * ($('div#root').css('zoom')),
            behavior: 'smooth'
        });
    })
}

main()
